import { type ProcedureTypeAttachment } from "@overmap-ai/common"
import { selectProcedureTypeAttachmentById } from "@overmap-ai/core"
import type { NodeViewProps } from "@tiptap/react"
import { memo } from "react"

import { sdk } from "../../../sdk"
import { useAppSelector } from "../../../store"
import { BaseAttachmentNodeComponent } from "../BaseAttachment/Component"
import { NotFoundAttachmentNode } from "../BaseAttachment/FallbackAttachmentNode"

export const ProcedureTypeAttachmentNodeComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const attachmentId = node.attrs.uuid as string
	const procedureTypeAttachment = useAppSelector(selectProcedureTypeAttachmentById(attachmentId))

	if (!procedureTypeAttachment) {
		return <NotFoundAttachmentNode {...props} />
	}

	return (
		<BaseAttachmentNodeComponent<ProcedureTypeAttachment>
			attachment={procedureTypeAttachment}
			service={sdk.procedureTypeAttachments}
			{...props}
		/>
	)
})
ProcedureTypeAttachmentNodeComponent.displayName = "ProcedureTypeAttachmentNodeComponent"
